import classNames from "classnames"
import { useMemo } from "react"

export type CStickyDisclaimerBlock = {
    id?: string
    typeHandle?: string
    disclaimerContent?: string
    verticalAlignment?: string
}

type Props = {
    field: Array<CStickyDisclaimerBlock>
}

const verticalMap: Record<string, string> = {
  top: "top-[130px]",
  bottom: "bottom-5",
}

export const CStickyDisclaimer = ({ field }: Props) => {
  const content = useMemo(() => {
      return field && field.length ? field[0] : null
  }, [field])

  if (!content?.disclaimerContent) {
      return <></>
  }

  return (
    <div 
      className={classNames(
        'c-sticky-disclaimer fixed left-0 right-0 z-50 flex justify-center select-none',
        verticalMap[content.verticalAlignment ?? 'top']
      )}
      role="complementary"
      aria-label="Legal disclosure notice"
    >
      <div className="text-xs bg-primary-teal text-neutral-white rounded-[21px] shadow-sm px-5 py-2 text-center max-w-[240px] md:max-w-none" dangerouslySetInnerHTML={{ __html: content.disclaimerContent }} />
    </div>
  )
}

export const CStickyDisclaimerFragments = {
    field: `
      fragment stickyDisclaimer on stickyDisclaimer_MatrixField {
        ... on stickyDisclaimer_block_BlockType {
          id
          typeHandle
          disclaimerContent
          verticalAlignment
        }
      }
    `,
  }
  